import actions from 'actions';

const initialState = {
  isAuthenticated: false,
  currentParticipantId: null,
  isLoadingMe: false,
  participants: [],
};

function participants(state = initialState, action) {
  switch (action.type) {
    case actions.participants.PARTICIPANT_LOGIN_SUCCESS:
      const base64Token = action.token.split('.')[1].replace('-', '+').replace('_', '/');
      const tokenData = JSON.parse(window.atob(base64Token));
      return Object.assign({}, state, {
        isAuthenticated: true,
        currentParticipantId: tokenData.sub.replace('participant-', ''),
      });
    case actions.participants.PARTICIPANT_LOGOUT_SUCCESS:
      return Object.assign({}, state, {
        isAuthenticated: false,
        currentParticipantId: null,
        participants: [],
      });
    case actions.participants.RECEIVE_PARTICIPANT: {
      console.log(state);
      const participants = [];
      let found = false;
      state.participants.forEach((participant) => {
        if (participant._id === action.participant._id) {
          participant = Object.assign({}, participant, action.participant);
          found = true;
        }
        participants.push(participant);
      });
      if (!found) participants.push(action.participant);
      return Object.assign({}, state, { loading: false, errorMessage: '', participants});
    }
    case actions.participants.START_LOADING_TRIAL: {
      return Object.assign({}, state, { isLoadingMe: true });
    }
    case actions.participants.FINISH_LOADING_TRIAL: {
      return Object.assign({}, state, { isLoadingMe: false });
    }
    case actions.participants.COMPLETE_STAGE: {
      const participants = Object.assign([], state.participants).map(p => {
        if (p._id === action.id) {
          p = Object.assign({}, p);
          p.completedTrialStages = Object.assign([], p.completedTrialStages);
          p.completedTrialStages.push(action.stage);
        }
        return p;
      });
      return Object.assign({}, state, { participants });
    }
    case actions.participants.RECEIVE_AGREEMENTS: {
      const participants = Object.assign([], state.participants).map(p => {
        if (p._id === action.id) {
          p = Object.assign({}, p);
          p.trialConditionAgreements = action.agreements;
        }
        return p;
      });
      return Object.assign({}, state, { participants });
    }
    default:
      return state;
  }
}

export default participants;
